import { render, staticRenderFns } from "./GeneralEarning.vue?vue&type=template&id=649ed2e8&"
import script from "./GeneralEarning.vue?vue&type=script&lang=js&"
export * from "./GeneralEarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports